/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface WorklogsService {
  /** @summary Clock In */
  clockInWorklogsClockInPost: {
    /** @summary Clock In */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        ClockInWorklogsClockInPostBody,
        ClockInWorklogsClockInPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: ClockInWorklogsClockInPostSchema,
        options: ServiceOperationMutationFnOptions<
          ClockInWorklogsClockInPostBody,
          ClockInWorklogsClockInPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<ClockInWorklogsClockInPostData, ClockInWorklogsClockInPostError>>
    ): Promise<RequestFnResponse<ClockInWorklogsClockInPostData, ClockInWorklogsClockInPostError>>;
    /** @summary Clock In */
    getMutationKey(
      parameters: DeepReadonly<ClockInWorklogsClockInPostParameters> | void
    ): ServiceOperationMutationKey<ClockInWorklogsClockInPostSchema, ClockInWorklogsClockInPostParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Clock In
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.worklogsService.clockInWorklogsClockInPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.worklogsService.clockInWorklogsClockInPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends ClockInWorklogsClockInPostBody, TContext = unknown>(
      parameters: DeepReadonly<ClockInWorklogsClockInPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        ClockInWorklogsClockInPostSchema,
        ClockInWorklogsClockInPostData,
        ClockInWorklogsClockInPostParameters,
        TVariables,
        OperationError<ClockInWorklogsClockInPostError>,
        TContext
      >
    ): UseMutationResult<
      ClockInWorklogsClockInPostData,
      OperationError<ClockInWorklogsClockInPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Clock In
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.worklogsService.clockInWorklogsClockInPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.worklogsService.clockInWorklogsClockInPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<ClockInWorklogsClockInPostBody, ClockInWorklogsClockInPostParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        ClockInWorklogsClockInPostSchema,
        ClockInWorklogsClockInPostData,
        ClockInWorklogsClockInPostParameters,
        TVariables,
        OperationError<ClockInWorklogsClockInPostError>,
        TContext
      >
    ): UseMutationResult<
      ClockInWorklogsClockInPostData,
      OperationError<ClockInWorklogsClockInPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Clock In
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const clockInWorklogsClockInPostTotal = qraft.worklogsService.clockInWorklogsClockInPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const clockInWorklogsClockInPostTotal = qraft.worklogsService.clockInWorklogsClockInPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            ClockInWorklogsClockInPostBody,
            ClockInWorklogsClockInPostData,
            ClockInWorklogsClockInPostParameters,
            OperationError<ClockInWorklogsClockInPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ClockInWorklogsClockInPostSchema,
            ClockInWorklogsClockInPostBody,
            ClockInWorklogsClockInPostData,
            ClockInWorklogsClockInPostParameters,
            OperationError<ClockInWorklogsClockInPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Clock In
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const clockInWorklogsClockInPostPendingMutationVariables = qraft.worklogsService.clockInWorklogsClockInPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const clockInWorklogsClockInPostMutationData = qraft.worklogsService.clockInWorklogsClockInPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        ClockInWorklogsClockInPostData,
        OperationError<ClockInWorklogsClockInPostError>,
        MutationVariables<ClockInWorklogsClockInPostBody, ClockInWorklogsClockInPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            ClockInWorklogsClockInPostBody,
            ClockInWorklogsClockInPostData,
            ClockInWorklogsClockInPostParameters,
            OperationError<ClockInWorklogsClockInPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ClockInWorklogsClockInPostSchema,
            ClockInWorklogsClockInPostBody,
            ClockInWorklogsClockInPostData,
            ClockInWorklogsClockInPostParameters,
            OperationError<ClockInWorklogsClockInPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          ClockInWorklogsClockInPostData,
          OperationError<ClockInWorklogsClockInPostError>,
          MutationVariables<ClockInWorklogsClockInPostBody, ClockInWorklogsClockInPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Clock In */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            ClockInWorklogsClockInPostBody,
            ClockInWorklogsClockInPostData,
            ClockInWorklogsClockInPostParameters,
            OperationError<ClockInWorklogsClockInPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ClockInWorklogsClockInPostSchema,
            ClockInWorklogsClockInPostBody,
            ClockInWorklogsClockInPostData,
            ClockInWorklogsClockInPostParameters,
            OperationError<ClockInWorklogsClockInPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Clock In
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.worklogsService.clockInWorklogsClockInPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.worklogsService.clockInWorklogsClockInPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              ClockInWorklogsClockInPostBody,
              ClockInWorklogsClockInPostData,
              ClockInWorklogsClockInPostParameters,
              OperationError<ClockInWorklogsClockInPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              ClockInWorklogsClockInPostSchema,
              ClockInWorklogsClockInPostBody,
              ClockInWorklogsClockInPostData,
              ClockInWorklogsClockInPostParameters,
              OperationError<ClockInWorklogsClockInPostError>,
              TContext
            >
      ):
        | Mutation<
            ClockInWorklogsClockInPostData,
            ClockInWorklogsClockInPostError,
            MutationVariables<ClockInWorklogsClockInPostBody, ClockInWorklogsClockInPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              ClockInWorklogsClockInPostBody,
              ClockInWorklogsClockInPostData,
              ClockInWorklogsClockInPostParameters,
              OperationError<ClockInWorklogsClockInPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              ClockInWorklogsClockInPostSchema,
              ClockInWorklogsClockInPostBody,
              ClockInWorklogsClockInPostData,
              ClockInWorklogsClockInPostParameters,
              OperationError<ClockInWorklogsClockInPostError>,
              TContext
            >
      ): Array<
        Mutation<
          ClockInWorklogsClockInPostData,
          ClockInWorklogsClockInPostError,
          MutationVariables<ClockInWorklogsClockInPostBody, ClockInWorklogsClockInPostParameters>,
          TContext
        >
      >;
    };
    schema: ClockInWorklogsClockInPostSchema;
    types: {
      parameters: ClockInWorklogsClockInPostParameters;
      data: ClockInWorklogsClockInPostData;
      error: ClockInWorklogsClockInPostError;
      body: ClockInWorklogsClockInPostBody;
    };
  };
  /** @summary Clock Out */
  clockOutWorklogsClockOutPut: {
    /** @summary Clock Out */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        ClockOutWorklogsClockOutPutBody,
        ClockOutWorklogsClockOutPutParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: ClockOutWorklogsClockOutPutSchema,
        options: ServiceOperationMutationFnOptions<
          ClockOutWorklogsClockOutPutBody,
          ClockOutWorklogsClockOutPutParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<ClockOutWorklogsClockOutPutData, ClockOutWorklogsClockOutPutError>>
    ): Promise<RequestFnResponse<ClockOutWorklogsClockOutPutData, ClockOutWorklogsClockOutPutError>>;
    /** @summary Clock Out */
    getMutationKey(
      parameters: DeepReadonly<ClockOutWorklogsClockOutPutParameters> | void
    ): ServiceOperationMutationKey<ClockOutWorklogsClockOutPutSchema, ClockOutWorklogsClockOutPutParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Clock Out
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.worklogsService.clockOutWorklogsClockOutPut.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.worklogsService.clockOutWorklogsClockOutPut.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends ClockOutWorklogsClockOutPutBody, TContext = unknown>(
      parameters: DeepReadonly<ClockOutWorklogsClockOutPutParameters>,
      options?: ServiceOperationUseMutationOptions<
        ClockOutWorklogsClockOutPutSchema,
        ClockOutWorklogsClockOutPutData,
        ClockOutWorklogsClockOutPutParameters,
        TVariables,
        OperationError<ClockOutWorklogsClockOutPutError>,
        TContext
      >
    ): UseMutationResult<
      ClockOutWorklogsClockOutPutData,
      OperationError<ClockOutWorklogsClockOutPutError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Clock Out
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.worklogsService.clockOutWorklogsClockOutPut.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.worklogsService.clockOutWorklogsClockOutPut.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<ClockOutWorklogsClockOutPutBody, ClockOutWorklogsClockOutPutParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        ClockOutWorklogsClockOutPutSchema,
        ClockOutWorklogsClockOutPutData,
        ClockOutWorklogsClockOutPutParameters,
        TVariables,
        OperationError<ClockOutWorklogsClockOutPutError>,
        TContext
      >
    ): UseMutationResult<
      ClockOutWorklogsClockOutPutData,
      OperationError<ClockOutWorklogsClockOutPutError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Clock Out
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const clockOutWorklogsClockOutPutTotal = qraft.worklogsService.clockOutWorklogsClockOutPut.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const clockOutWorklogsClockOutPutTotal = qraft.worklogsService.clockOutWorklogsClockOutPut.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            ClockOutWorklogsClockOutPutBody,
            ClockOutWorklogsClockOutPutData,
            ClockOutWorklogsClockOutPutParameters,
            OperationError<ClockOutWorklogsClockOutPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ClockOutWorklogsClockOutPutSchema,
            ClockOutWorklogsClockOutPutBody,
            ClockOutWorklogsClockOutPutData,
            ClockOutWorklogsClockOutPutParameters,
            OperationError<ClockOutWorklogsClockOutPutError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Clock Out
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const clockOutWorklogsClockOutPutPendingMutationVariables = qraft.worklogsService.clockOutWorklogsClockOutPut.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const clockOutWorklogsClockOutPutMutationData = qraft.worklogsService.clockOutWorklogsClockOutPut.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        ClockOutWorklogsClockOutPutData,
        OperationError<ClockOutWorklogsClockOutPutError>,
        MutationVariables<ClockOutWorklogsClockOutPutBody, ClockOutWorklogsClockOutPutParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            ClockOutWorklogsClockOutPutBody,
            ClockOutWorklogsClockOutPutData,
            ClockOutWorklogsClockOutPutParameters,
            OperationError<ClockOutWorklogsClockOutPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ClockOutWorklogsClockOutPutSchema,
            ClockOutWorklogsClockOutPutBody,
            ClockOutWorklogsClockOutPutData,
            ClockOutWorklogsClockOutPutParameters,
            OperationError<ClockOutWorklogsClockOutPutError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          ClockOutWorklogsClockOutPutData,
          OperationError<ClockOutWorklogsClockOutPutError>,
          MutationVariables<ClockOutWorklogsClockOutPutBody, ClockOutWorklogsClockOutPutParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Clock Out */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            ClockOutWorklogsClockOutPutBody,
            ClockOutWorklogsClockOutPutData,
            ClockOutWorklogsClockOutPutParameters,
            OperationError<ClockOutWorklogsClockOutPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ClockOutWorklogsClockOutPutSchema,
            ClockOutWorklogsClockOutPutBody,
            ClockOutWorklogsClockOutPutData,
            ClockOutWorklogsClockOutPutParameters,
            OperationError<ClockOutWorklogsClockOutPutError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Clock Out
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.worklogsService.clockOutWorklogsClockOutPut.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.worklogsService.clockOutWorklogsClockOutPut.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              ClockOutWorklogsClockOutPutBody,
              ClockOutWorklogsClockOutPutData,
              ClockOutWorklogsClockOutPutParameters,
              OperationError<ClockOutWorklogsClockOutPutError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              ClockOutWorklogsClockOutPutSchema,
              ClockOutWorklogsClockOutPutBody,
              ClockOutWorklogsClockOutPutData,
              ClockOutWorklogsClockOutPutParameters,
              OperationError<ClockOutWorklogsClockOutPutError>,
              TContext
            >
      ):
        | Mutation<
            ClockOutWorklogsClockOutPutData,
            ClockOutWorklogsClockOutPutError,
            MutationVariables<ClockOutWorklogsClockOutPutBody, ClockOutWorklogsClockOutPutParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              ClockOutWorklogsClockOutPutBody,
              ClockOutWorklogsClockOutPutData,
              ClockOutWorklogsClockOutPutParameters,
              OperationError<ClockOutWorklogsClockOutPutError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              ClockOutWorklogsClockOutPutSchema,
              ClockOutWorklogsClockOutPutBody,
              ClockOutWorklogsClockOutPutData,
              ClockOutWorklogsClockOutPutParameters,
              OperationError<ClockOutWorklogsClockOutPutError>,
              TContext
            >
      ): Array<
        Mutation<
          ClockOutWorklogsClockOutPutData,
          ClockOutWorklogsClockOutPutError,
          MutationVariables<ClockOutWorklogsClockOutPutBody, ClockOutWorklogsClockOutPutParameters>,
          TContext
        >
      >;
    };
    schema: ClockOutWorklogsClockOutPutSchema;
    types: {
      parameters: ClockOutWorklogsClockOutPutParameters;
      data: ClockOutWorklogsClockOutPutData;
      error: ClockOutWorklogsClockOutPutError;
      body: ClockOutWorklogsClockOutPutBody;
    };
  };
  /** @summary Get Current */
  getCurrentWorklogsCurrentGet: {
    /** @summary Get Current */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetCurrentWorklogsCurrentGetSchema,
            GetCurrentWorklogsCurrentGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<GetCurrentWorklogsCurrentGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetCurrentWorklogsCurrentGetSchema,
        options: {
          parameters: GetCurrentWorklogsCurrentGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetCurrentWorklogsCurrentGetData, GetCurrentWorklogsCurrentGetError>>
    ): Promise<RequestFnResponse<GetCurrentWorklogsCurrentGetData, GetCurrentWorklogsCurrentGetError>>;
    /** @summary Get Current */
    getQueryKey(
      parameters: DeepReadonly<GetCurrentWorklogsCurrentGetParameters> | void
    ): ServiceOperationQueryKey<GetCurrentWorklogsCurrentGetSchema, GetCurrentWorklogsCurrentGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Current
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.worklogsService.getCurrentWorklogsCurrentGet.useQuery()
     * ```
     */
    useQuery<TData = GetCurrentWorklogsCurrentGetData>(
      parameters:
        | ServiceOperationQueryKey<GetCurrentWorklogsCurrentGetSchema, GetCurrentWorklogsCurrentGetParameters>
        | (DeepReadonly<GetCurrentWorklogsCurrentGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetCurrentWorklogsCurrentGetData,
          GetCurrentWorklogsCurrentGetError,
          TData,
          ServiceOperationQueryKey<GetCurrentWorklogsCurrentGetSchema, GetCurrentWorklogsCurrentGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetCurrentWorklogsCurrentGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Current
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.worklogsService.getCurrentWorklogsCurrentGet.useQuery()
     * ```
     */
    useQuery<TData = GetCurrentWorklogsCurrentGetData>(
      parameters:
        | ServiceOperationQueryKey<GetCurrentWorklogsCurrentGetSchema, GetCurrentWorklogsCurrentGetParameters>
        | (DeepReadonly<GetCurrentWorklogsCurrentGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetCurrentWorklogsCurrentGetData,
          GetCurrentWorklogsCurrentGetError,
          TData,
          ServiceOperationQueryKey<GetCurrentWorklogsCurrentGetSchema, GetCurrentWorklogsCurrentGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetCurrentWorklogsCurrentGetError>>;
    /** @summary Get Current */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetCurrentWorklogsCurrentGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<GetCurrentWorklogsCurrentGetSchema, GetCurrentWorklogsCurrentGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Current
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.worklogsService.getCurrentWorklogsCurrentGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetCurrentWorklogsCurrentGetParameters,
      TQueryFnData = GetCurrentWorklogsCurrentGetData,
      TData = OperationInfiniteData<TQueryFnData, GetCurrentWorklogsCurrentGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetCurrentWorklogsCurrentGetSchema, GetCurrentWorklogsCurrentGetParameters>
        | (DeepReadonly<GetCurrentWorklogsCurrentGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetCurrentWorklogsCurrentGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetCurrentWorklogsCurrentGetSchema, GetCurrentWorklogsCurrentGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetCurrentWorklogsCurrentGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Current
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.worklogsService.getCurrentWorklogsCurrentGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetCurrentWorklogsCurrentGetParameters,
      TQueryFnData = GetCurrentWorklogsCurrentGetData,
      TData = OperationInfiniteData<TQueryFnData, GetCurrentWorklogsCurrentGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetCurrentWorklogsCurrentGetSchema, GetCurrentWorklogsCurrentGetParameters>
        | (DeepReadonly<GetCurrentWorklogsCurrentGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetCurrentWorklogsCurrentGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetCurrentWorklogsCurrentGetSchema, GetCurrentWorklogsCurrentGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetCurrentWorklogsCurrentGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetCurrentWorklogsCurrentGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Current
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getCurrentWorklogsCurrentGetTotal = qraft.worklogsService.getCurrentWorklogsCurrentGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCurrentWorklogsCurrentGetSchema,
            GetCurrentWorklogsCurrentGetData,
            TInfinite,
            GetCurrentWorklogsCurrentGetParameters,
            GetCurrentWorklogsCurrentGetError
          >
        | QueryFiltersByQueryKey<
            GetCurrentWorklogsCurrentGetSchema,
            GetCurrentWorklogsCurrentGetData,
            TInfinite,
            GetCurrentWorklogsCurrentGetParameters,
            GetCurrentWorklogsCurrentGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Current
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getCurrentWorklogsCurrentGetResults = qraft.worklogsService.getCurrentWorklogsCurrentGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getCurrentWorklogsCurrentGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getCurrentWorklogsCurrentGetCombinedResults = qraft.worklogsService.getCurrentWorklogsCurrentGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getCurrentWorklogsCurrentGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetCurrentWorklogsCurrentGetSchema,
          GetCurrentWorklogsCurrentGetParameters,
          GetCurrentWorklogsCurrentGetData,
          GetCurrentWorklogsCurrentGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetCurrentWorklogsCurrentGetData, GetCurrentWorklogsCurrentGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<GetCurrentWorklogsCurrentGetData, GetCurrentWorklogsCurrentGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Current
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.worklogsService.getCurrentWorklogsCurrentGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = GetCurrentWorklogsCurrentGetData>(
      parameters:
        | ServiceOperationQueryKey<GetCurrentWorklogsCurrentGetSchema, GetCurrentWorklogsCurrentGetParameters>
        | (DeepReadonly<GetCurrentWorklogsCurrentGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetCurrentWorklogsCurrentGetData,
          GetCurrentWorklogsCurrentGetError,
          TData,
          ServiceOperationQueryKey<GetCurrentWorklogsCurrentGetSchema, GetCurrentWorklogsCurrentGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetCurrentWorklogsCurrentGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Current
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.worklogsService.getCurrentWorklogsCurrentGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetCurrentWorklogsCurrentGetParameters,
      TData = GetCurrentWorklogsCurrentGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetCurrentWorklogsCurrentGetSchema, GetCurrentWorklogsCurrentGetParameters>
        | (DeepReadonly<GetCurrentWorklogsCurrentGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetCurrentWorklogsCurrentGetData,
          GetCurrentWorklogsCurrentGetError,
          OperationInfiniteData<TData, GetCurrentWorklogsCurrentGetParameters>,
          ServiceOperationInfiniteQueryKey<GetCurrentWorklogsCurrentGetSchema, GetCurrentWorklogsCurrentGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetCurrentWorklogsCurrentGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetCurrentWorklogsCurrentGetParameters>,
      OperationError<GetCurrentWorklogsCurrentGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Current
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getCurrentWorklogsCurrentGetData = qraft.worklogsService.getCurrentWorklogsCurrentGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getCurrentWorklogsCurrentGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getCurrentWorklogsCurrentGetCombinedData = qraft.worklogsService.getCurrentWorklogsCurrentGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getCurrentWorklogsCurrentGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetCurrentWorklogsCurrentGetSchema,
          GetCurrentWorklogsCurrentGetParameters,
          GetCurrentWorklogsCurrentGetData,
          GetCurrentWorklogsCurrentGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<GetCurrentWorklogsCurrentGetData, GetCurrentWorklogsCurrentGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<GetCurrentWorklogsCurrentGetData, GetCurrentWorklogsCurrentGetError>,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get Current */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetCurrentWorklogsCurrentGetSchema,
        GetCurrentWorklogsCurrentGetData,
        GetCurrentWorklogsCurrentGetParameters,
        GetCurrentWorklogsCurrentGetError
      > | void
    ): Promise<GetCurrentWorklogsCurrentGetData>;
    /** @summary Get Current */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetCurrentWorklogsCurrentGetSchema,
        GetCurrentWorklogsCurrentGetData,
        GetCurrentWorklogsCurrentGetParameters,
        GetCurrentWorklogsCurrentGetError
      > | void
    ): Promise<void>;
    /** @summary Get Current */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetCurrentWorklogsCurrentGetSchema,
        GetCurrentWorklogsCurrentGetData,
        GetCurrentWorklogsCurrentGetParameters,
        GetCurrentWorklogsCurrentGetError
      > | void
    ): Promise<GetCurrentWorklogsCurrentGetData>;
    /** @summary Get Current */
    fetchInfiniteQuery<TPageParam extends GetCurrentWorklogsCurrentGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetCurrentWorklogsCurrentGetSchema,
        GetCurrentWorklogsCurrentGetData,
        GetCurrentWorklogsCurrentGetParameters,
        DeepReadonly<TPageParam>,
        GetCurrentWorklogsCurrentGetError
      > | void
    ): Promise<OperationInfiniteData<GetCurrentWorklogsCurrentGetData, GetCurrentWorklogsCurrentGetParameters>>;
    /** @summary Get Current */
    prefetchInfiniteQuery<TPageParam extends GetCurrentWorklogsCurrentGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetCurrentWorklogsCurrentGetSchema,
        GetCurrentWorklogsCurrentGetData,
        GetCurrentWorklogsCurrentGetParameters,
        DeepReadonly<TPageParam>,
        GetCurrentWorklogsCurrentGetError
      > | void
    ): Promise<void>;
    /** @summary Get Current */
    ensureInfiniteQueryData<TPageParam extends GetCurrentWorklogsCurrentGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetCurrentWorklogsCurrentGetSchema,
        GetCurrentWorklogsCurrentGetData,
        GetCurrentWorklogsCurrentGetParameters,
        DeepReadonly<TPageParam>,
        GetCurrentWorklogsCurrentGetError
      > | void
    ): Promise<OperationInfiniteData<GetCurrentWorklogsCurrentGetData, GetCurrentWorklogsCurrentGetParameters>>;
    /** @summary Get Current */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetCurrentWorklogsCurrentGetSchema, GetCurrentWorklogsCurrentGetParameters>
        | (DeepReadonly<GetCurrentWorklogsCurrentGetParameters> | void)
    ): GetCurrentWorklogsCurrentGetData | undefined;
    /** @summary Get Current */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetCurrentWorklogsCurrentGetSchema, GetCurrentWorklogsCurrentGetParameters>
        | (DeepReadonly<GetCurrentWorklogsCurrentGetParameters> | void)
    ): OperationInfiniteData<GetCurrentWorklogsCurrentGetData, GetCurrentWorklogsCurrentGetParameters> | undefined;
    /** @summary Get Current */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCurrentWorklogsCurrentGetSchema,
            GetCurrentWorklogsCurrentGetData,
            TInfinite,
            GetCurrentWorklogsCurrentGetParameters,
            GetCurrentWorklogsCurrentGetError
          >
        | QueryFiltersByQueryKey<
            GetCurrentWorklogsCurrentGetSchema,
            GetCurrentWorklogsCurrentGetData,
            TInfinite,
            GetCurrentWorklogsCurrentGetParameters,
            GetCurrentWorklogsCurrentGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetCurrentWorklogsCurrentGetSchema,
              GetCurrentWorklogsCurrentGetParameters
            >,
            data:
              | NoInfer<OperationInfiniteData<GetCurrentWorklogsCurrentGetData, GetCurrentWorklogsCurrentGetParameters>>
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetCurrentWorklogsCurrentGetSchema,
              GetCurrentWorklogsCurrentGetParameters
            >,
            data: GetCurrentWorklogsCurrentGetData | undefined,
          ]
        >;
    /** @summary Get Current */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetCurrentWorklogsCurrentGetSchema, GetCurrentWorklogsCurrentGetParameters>
        | (DeepReadonly<GetCurrentWorklogsCurrentGetParameters> | void)
    ): QueryState<GetCurrentWorklogsCurrentGetData, GetCurrentWorklogsCurrentGetError> | undefined;
    /** @summary Get Current */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetCurrentWorklogsCurrentGetParameters>
        | ServiceOperationInfiniteQueryKey<GetCurrentWorklogsCurrentGetSchema, GetCurrentWorklogsCurrentGetParameters>
        | void
    ):
      | QueryState<
          OperationInfiniteData<GetCurrentWorklogsCurrentGetData, GetCurrentWorklogsCurrentGetParameters>,
          GetCurrentWorklogsCurrentGetError
        >
      | undefined;
    /** @summary Get Current */
    setQueryData(
      parameters:
        | (DeepReadonly<GetCurrentWorklogsCurrentGetParameters> | undefined)
        | ServiceOperationQueryKey<GetCurrentWorklogsCurrentGetSchema, GetCurrentWorklogsCurrentGetParameters>,
      updater: Updater<
        NoInfer<GetCurrentWorklogsCurrentGetData> | undefined,
        NoInfer<DeepReadonly<GetCurrentWorklogsCurrentGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetCurrentWorklogsCurrentGetData | undefined;
    /** @summary Get Current */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetCurrentWorklogsCurrentGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<GetCurrentWorklogsCurrentGetSchema, GetCurrentWorklogsCurrentGetParameters>,
      updater: Updater<
        | NoInfer<OperationInfiniteData<GetCurrentWorklogsCurrentGetData, GetCurrentWorklogsCurrentGetParameters>>
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<GetCurrentWorklogsCurrentGetData, GetCurrentWorklogsCurrentGetParameters>
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetCurrentWorklogsCurrentGetData, GetCurrentWorklogsCurrentGetParameters> | undefined;
    /** @summary Get Current */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetCurrentWorklogsCurrentGetSchema,
            GetCurrentWorklogsCurrentGetData,
            TInfinite,
            GetCurrentWorklogsCurrentGetParameters,
            GetCurrentWorklogsCurrentGetError
          >
        | QueryFiltersByQueryKey<
            GetCurrentWorklogsCurrentGetSchema,
            GetCurrentWorklogsCurrentGetData,
            TInfinite,
            GetCurrentWorklogsCurrentGetParameters,
            GetCurrentWorklogsCurrentGetError
          >,
      updater: Updater<
        NoInfer<GetCurrentWorklogsCurrentGetData> | undefined,
        NoInfer<GetCurrentWorklogsCurrentGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetCurrentWorklogsCurrentGetData | undefined>;
    /** @summary Get Current */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetCurrentWorklogsCurrentGetSchema,
        GetCurrentWorklogsCurrentGetData,
        TInfinite,
        GetCurrentWorklogsCurrentGetParameters,
        GetCurrentWorklogsCurrentGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get Current */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCurrentWorklogsCurrentGetSchema,
            GetCurrentWorklogsCurrentGetData,
            TInfinite,
            GetCurrentWorklogsCurrentGetParameters,
            GetCurrentWorklogsCurrentGetError
          >
        | QueryFiltersByQueryKey<
            GetCurrentWorklogsCurrentGetSchema,
            GetCurrentWorklogsCurrentGetData,
            TInfinite,
            GetCurrentWorklogsCurrentGetParameters,
            GetCurrentWorklogsCurrentGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get Current */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCurrentWorklogsCurrentGetSchema,
            GetCurrentWorklogsCurrentGetData,
            TInfinite,
            GetCurrentWorklogsCurrentGetParameters,
            GetCurrentWorklogsCurrentGetError
          >
        | QueryFiltersByQueryKey<
            GetCurrentWorklogsCurrentGetSchema,
            GetCurrentWorklogsCurrentGetData,
            TInfinite,
            GetCurrentWorklogsCurrentGetParameters,
            GetCurrentWorklogsCurrentGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get Current */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCurrentWorklogsCurrentGetSchema,
            GetCurrentWorklogsCurrentGetData,
            TInfinite,
            GetCurrentWorklogsCurrentGetParameters,
            GetCurrentWorklogsCurrentGetError
          >
        | QueryFiltersByQueryKey<
            GetCurrentWorklogsCurrentGetSchema,
            GetCurrentWorklogsCurrentGetData,
            TInfinite,
            GetCurrentWorklogsCurrentGetParameters,
            GetCurrentWorklogsCurrentGetError
          >
    ): void;
    /** @summary Get Current */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCurrentWorklogsCurrentGetSchema,
            GetCurrentWorklogsCurrentGetData,
            TInfinite,
            GetCurrentWorklogsCurrentGetParameters,
            GetCurrentWorklogsCurrentGetError
          >
        | QueryFiltersByQueryKey<
            GetCurrentWorklogsCurrentGetSchema,
            GetCurrentWorklogsCurrentGetData,
            TInfinite,
            GetCurrentWorklogsCurrentGetParameters,
            GetCurrentWorklogsCurrentGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get Current */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCurrentWorklogsCurrentGetSchema,
            GetCurrentWorklogsCurrentGetData,
            TInfinite,
            GetCurrentWorklogsCurrentGetParameters,
            GetCurrentWorklogsCurrentGetError
          >
        | QueryFiltersByQueryKey<
            GetCurrentWorklogsCurrentGetSchema,
            GetCurrentWorklogsCurrentGetData,
            TInfinite,
            GetCurrentWorklogsCurrentGetParameters,
            GetCurrentWorklogsCurrentGetError
          >
    ): number;
    schema: GetCurrentWorklogsCurrentGetSchema;
    types: {
      parameters: GetCurrentWorklogsCurrentGetParameters;
      data: GetCurrentWorklogsCurrentGetData;
      error: GetCurrentWorklogsCurrentGetError;
    };
  };
  /** @summary List Worklogs */
  listWorklogsWorklogsGet: {
    /** @summary List Worklogs */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<ListWorklogsWorklogsGetSchema, ListWorklogsWorklogsGetParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<ListWorklogsWorklogsGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: ListWorklogsWorklogsGetSchema,
        options: {
          parameters: ListWorklogsWorklogsGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<ListWorklogsWorklogsGetData, ListWorklogsWorklogsGetError>>
    ): Promise<RequestFnResponse<ListWorklogsWorklogsGetData, ListWorklogsWorklogsGetError>>;
    /** @summary List Worklogs */
    getQueryKey(
      parameters: DeepReadonly<ListWorklogsWorklogsGetParameters> | void
    ): ServiceOperationQueryKey<ListWorklogsWorklogsGetSchema, ListWorklogsWorklogsGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Worklogs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.worklogsService.listWorklogsWorklogsGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.worklogsService.listWorklogsWorklogsGet.useQuery({
     *     query: {
     *         page: page
     *     }
     * })
     * ```
     */
    useQuery<TData = ListWorklogsWorklogsGetData>(
      parameters:
        | ServiceOperationQueryKey<ListWorklogsWorklogsGetSchema, ListWorklogsWorklogsGetParameters>
        | (DeepReadonly<ListWorklogsWorklogsGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ListWorklogsWorklogsGetData,
          ListWorklogsWorklogsGetError,
          TData,
          ServiceOperationQueryKey<ListWorklogsWorklogsGetSchema, ListWorklogsWorklogsGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ListWorklogsWorklogsGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Worklogs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.worklogsService.listWorklogsWorklogsGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.worklogsService.listWorklogsWorklogsGet.useQuery({
     *     query: {
     *         page: page
     *     }
     * })
     * ```
     */
    useQuery<TData = ListWorklogsWorklogsGetData>(
      parameters:
        | ServiceOperationQueryKey<ListWorklogsWorklogsGetSchema, ListWorklogsWorklogsGetParameters>
        | (DeepReadonly<ListWorklogsWorklogsGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ListWorklogsWorklogsGetData,
          ListWorklogsWorklogsGetError,
          TData,
          ServiceOperationQueryKey<ListWorklogsWorklogsGetSchema, ListWorklogsWorklogsGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ListWorklogsWorklogsGetError>>;
    /** @summary List Worklogs */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListWorklogsWorklogsGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<ListWorklogsWorklogsGetSchema, ListWorklogsWorklogsGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Worklogs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.worklogsService.listWorklogsWorklogsGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             page: initialPage
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListWorklogsWorklogsGetParameters,
      TQueryFnData = ListWorklogsWorklogsGetData,
      TData = OperationInfiniteData<TQueryFnData, ListWorklogsWorklogsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListWorklogsWorklogsGetSchema, ListWorklogsWorklogsGetParameters>
        | (DeepReadonly<ListWorklogsWorklogsGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListWorklogsWorklogsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<ListWorklogsWorklogsGetSchema, ListWorklogsWorklogsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ListWorklogsWorklogsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Worklogs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.worklogsService.listWorklogsWorklogsGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             page: initialPage
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListWorklogsWorklogsGetParameters,
      TQueryFnData = ListWorklogsWorklogsGetData,
      TData = OperationInfiniteData<TQueryFnData, ListWorklogsWorklogsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListWorklogsWorklogsGetSchema, ListWorklogsWorklogsGetParameters>
        | (DeepReadonly<ListWorklogsWorklogsGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListWorklogsWorklogsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<ListWorklogsWorklogsGetSchema, ListWorklogsWorklogsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListWorklogsWorklogsGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ListWorklogsWorklogsGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary List Worklogs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listWorklogsWorklogsGetTotal = qraft.worklogsService.listWorklogsWorklogsGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const listWorklogsWorklogsGetByParametersTotal = qraft.worklogsService.listWorklogsWorklogsGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             page: page
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListWorklogsWorklogsGetSchema,
            ListWorklogsWorklogsGetData,
            TInfinite,
            ListWorklogsWorklogsGetParameters,
            ListWorklogsWorklogsGetError
          >
        | QueryFiltersByQueryKey<
            ListWorklogsWorklogsGetSchema,
            ListWorklogsWorklogsGetData,
            TInfinite,
            ListWorklogsWorklogsGetParameters,
            ListWorklogsWorklogsGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary List Worklogs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listWorklogsWorklogsGetResults = qraft.worklogsService.listWorklogsWorklogsGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 page: page1
     *             }
     *         },
     *         {
     *             query: {
     *                 page: page2
     *             }
     *         }
     *     ]
     * });
     * listWorklogsWorklogsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listWorklogsWorklogsGetCombinedResults = qraft.worklogsService.listWorklogsWorklogsGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 page: page1
     *             }
     *         },
     *         {
     *             query: {
     *                 page: page2
     *             }
     *         }
     *     ]
     * });
     * listWorklogsWorklogsGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ListWorklogsWorklogsGetSchema,
          ListWorklogsWorklogsGetParameters,
          ListWorklogsWorklogsGetData,
          ListWorklogsWorklogsGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<ListWorklogsWorklogsGetData, ListWorklogsWorklogsGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<ListWorklogsWorklogsGetData, ListWorklogsWorklogsGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary List Worklogs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.worklogsService.listWorklogsWorklogsGet.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.worklogsService.listWorklogsWorklogsGet.useSuspenseQuery({
     *     query: {
     *         page: page
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = ListWorklogsWorklogsGetData>(
      parameters:
        | ServiceOperationQueryKey<ListWorklogsWorklogsGetSchema, ListWorklogsWorklogsGetParameters>
        | (DeepReadonly<ListWorklogsWorklogsGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ListWorklogsWorklogsGetData,
          ListWorklogsWorklogsGetError,
          TData,
          ServiceOperationQueryKey<ListWorklogsWorklogsGetSchema, ListWorklogsWorklogsGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ListWorklogsWorklogsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary List Worklogs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.worklogsService.listWorklogsWorklogsGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             page: initialPage
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends ListWorklogsWorklogsGetParameters, TData = ListWorklogsWorklogsGetData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListWorklogsWorklogsGetSchema, ListWorklogsWorklogsGetParameters>
        | (DeepReadonly<ListWorklogsWorklogsGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListWorklogsWorklogsGetData,
          ListWorklogsWorklogsGetError,
          OperationInfiniteData<TData, ListWorklogsWorklogsGetParameters>,
          ServiceOperationInfiniteQueryKey<ListWorklogsWorklogsGetSchema, ListWorklogsWorklogsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListWorklogsWorklogsGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListWorklogsWorklogsGetParameters>,
      OperationError<ListWorklogsWorklogsGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary List Worklogs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listWorklogsWorklogsGetData = qraft.worklogsService.listWorklogsWorklogsGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 page: page1
     *             }
     *         },
     *         {
     *             query: {
     *                 page: page2
     *             }
     *         }
     *     ]
     * });
     * listWorklogsWorklogsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listWorklogsWorklogsGetCombinedData = qraft.worklogsService.listWorklogsWorklogsGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 page: page1
     *             }
     *         },
     *         {
     *             query: {
     *                 page: page2
     *             }
     *         }
     *     ]
     * });
     * listWorklogsWorklogsGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ListWorklogsWorklogsGetSchema,
          ListWorklogsWorklogsGetParameters,
          ListWorklogsWorklogsGetData,
          ListWorklogsWorklogsGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<ListWorklogsWorklogsGetData, ListWorklogsWorklogsGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<UseSuspenseQueryResult<ListWorklogsWorklogsGetData, ListWorklogsWorklogsGetError>, 'data'>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary List Worklogs */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListWorklogsWorklogsGetSchema,
        ListWorklogsWorklogsGetData,
        ListWorklogsWorklogsGetParameters,
        ListWorklogsWorklogsGetError
      > | void
    ): Promise<ListWorklogsWorklogsGetData>;
    /** @summary List Worklogs */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListWorklogsWorklogsGetSchema,
        ListWorklogsWorklogsGetData,
        ListWorklogsWorklogsGetParameters,
        ListWorklogsWorklogsGetError
      > | void
    ): Promise<void>;
    /** @summary List Worklogs */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListWorklogsWorklogsGetSchema,
        ListWorklogsWorklogsGetData,
        ListWorklogsWorklogsGetParameters,
        ListWorklogsWorklogsGetError
      > | void
    ): Promise<ListWorklogsWorklogsGetData>;
    /** @summary List Worklogs */
    fetchInfiniteQuery<TPageParam extends ListWorklogsWorklogsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListWorklogsWorklogsGetSchema,
        ListWorklogsWorklogsGetData,
        ListWorklogsWorklogsGetParameters,
        DeepReadonly<TPageParam>,
        ListWorklogsWorklogsGetError
      > | void
    ): Promise<OperationInfiniteData<ListWorklogsWorklogsGetData, ListWorklogsWorklogsGetParameters>>;
    /** @summary List Worklogs */
    prefetchInfiniteQuery<TPageParam extends ListWorklogsWorklogsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListWorklogsWorklogsGetSchema,
        ListWorklogsWorklogsGetData,
        ListWorklogsWorklogsGetParameters,
        DeepReadonly<TPageParam>,
        ListWorklogsWorklogsGetError
      > | void
    ): Promise<void>;
    /** @summary List Worklogs */
    ensureInfiniteQueryData<TPageParam extends ListWorklogsWorklogsGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListWorklogsWorklogsGetSchema,
        ListWorklogsWorklogsGetData,
        ListWorklogsWorklogsGetParameters,
        DeepReadonly<TPageParam>,
        ListWorklogsWorklogsGetError
      > | void
    ): Promise<OperationInfiniteData<ListWorklogsWorklogsGetData, ListWorklogsWorklogsGetParameters>>;
    /** @summary List Worklogs */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<ListWorklogsWorklogsGetSchema, ListWorklogsWorklogsGetParameters>
        | (DeepReadonly<ListWorklogsWorklogsGetParameters> | void)
    ): ListWorklogsWorklogsGetData | undefined;
    /** @summary List Worklogs */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListWorklogsWorklogsGetSchema, ListWorklogsWorklogsGetParameters>
        | (DeepReadonly<ListWorklogsWorklogsGetParameters> | void)
    ): OperationInfiniteData<ListWorklogsWorklogsGetData, ListWorklogsWorklogsGetParameters> | undefined;
    /** @summary List Worklogs */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListWorklogsWorklogsGetSchema,
            ListWorklogsWorklogsGetData,
            TInfinite,
            ListWorklogsWorklogsGetParameters,
            ListWorklogsWorklogsGetError
          >
        | QueryFiltersByQueryKey<
            ListWorklogsWorklogsGetSchema,
            ListWorklogsWorklogsGetData,
            TInfinite,
            ListWorklogsWorklogsGetParameters,
            ListWorklogsWorklogsGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              ListWorklogsWorklogsGetSchema,
              ListWorklogsWorklogsGetParameters
            >,
            data:
              | NoInfer<OperationInfiniteData<ListWorklogsWorklogsGetData, ListWorklogsWorklogsGetParameters>>
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<ListWorklogsWorklogsGetSchema, ListWorklogsWorklogsGetParameters>,
            data: ListWorklogsWorklogsGetData | undefined,
          ]
        >;
    /** @summary List Worklogs */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<ListWorklogsWorklogsGetSchema, ListWorklogsWorklogsGetParameters>
        | (DeepReadonly<ListWorklogsWorklogsGetParameters> | void)
    ): QueryState<ListWorklogsWorklogsGetData, ListWorklogsWorklogsGetError> | undefined;
    /** @summary List Worklogs */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListWorklogsWorklogsGetParameters>
        | ServiceOperationInfiniteQueryKey<ListWorklogsWorklogsGetSchema, ListWorklogsWorklogsGetParameters>
        | void
    ):
      | QueryState<
          OperationInfiniteData<ListWorklogsWorklogsGetData, ListWorklogsWorklogsGetParameters>,
          ListWorklogsWorklogsGetError
        >
      | undefined;
    /** @summary List Worklogs */
    setQueryData(
      parameters:
        | (DeepReadonly<ListWorklogsWorklogsGetParameters> | undefined)
        | ServiceOperationQueryKey<ListWorklogsWorklogsGetSchema, ListWorklogsWorklogsGetParameters>,
      updater: Updater<
        NoInfer<ListWorklogsWorklogsGetData> | undefined,
        NoInfer<DeepReadonly<ListWorklogsWorklogsGetData>> | undefined
      >,
      options?: SetDataOptions
    ): ListWorklogsWorklogsGetData | undefined;
    /** @summary List Worklogs */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ListWorklogsWorklogsGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<ListWorklogsWorklogsGetSchema, ListWorklogsWorklogsGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<ListWorklogsWorklogsGetData, ListWorklogsWorklogsGetParameters>> | undefined,
        | NoInfer<DeepReadonly<OperationInfiniteData<ListWorklogsWorklogsGetData, ListWorklogsWorklogsGetParameters>>>
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<ListWorklogsWorklogsGetData, ListWorklogsWorklogsGetParameters> | undefined;
    /** @summary List Worklogs */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ListWorklogsWorklogsGetSchema,
            ListWorklogsWorklogsGetData,
            TInfinite,
            ListWorklogsWorklogsGetParameters,
            ListWorklogsWorklogsGetError
          >
        | QueryFiltersByQueryKey<
            ListWorklogsWorklogsGetSchema,
            ListWorklogsWorklogsGetData,
            TInfinite,
            ListWorklogsWorklogsGetParameters,
            ListWorklogsWorklogsGetError
          >,
      updater: Updater<
        NoInfer<ListWorklogsWorklogsGetData> | undefined,
        NoInfer<ListWorklogsWorklogsGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<ListWorklogsWorklogsGetData | undefined>;
    /** @summary List Worklogs */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListWorklogsWorklogsGetSchema,
        ListWorklogsWorklogsGetData,
        TInfinite,
        ListWorklogsWorklogsGetParameters,
        ListWorklogsWorklogsGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary List Worklogs */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListWorklogsWorklogsGetSchema,
            ListWorklogsWorklogsGetData,
            TInfinite,
            ListWorklogsWorklogsGetParameters,
            ListWorklogsWorklogsGetError
          >
        | QueryFiltersByQueryKey<
            ListWorklogsWorklogsGetSchema,
            ListWorklogsWorklogsGetData,
            TInfinite,
            ListWorklogsWorklogsGetParameters,
            ListWorklogsWorklogsGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary List Worklogs */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListWorklogsWorklogsGetSchema,
            ListWorklogsWorklogsGetData,
            TInfinite,
            ListWorklogsWorklogsGetParameters,
            ListWorklogsWorklogsGetError
          >
        | QueryFiltersByQueryKey<
            ListWorklogsWorklogsGetSchema,
            ListWorklogsWorklogsGetData,
            TInfinite,
            ListWorklogsWorklogsGetParameters,
            ListWorklogsWorklogsGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary List Worklogs */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListWorklogsWorklogsGetSchema,
            ListWorklogsWorklogsGetData,
            TInfinite,
            ListWorklogsWorklogsGetParameters,
            ListWorklogsWorklogsGetError
          >
        | QueryFiltersByQueryKey<
            ListWorklogsWorklogsGetSchema,
            ListWorklogsWorklogsGetData,
            TInfinite,
            ListWorklogsWorklogsGetParameters,
            ListWorklogsWorklogsGetError
          >
    ): void;
    /** @summary List Worklogs */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListWorklogsWorklogsGetSchema,
            ListWorklogsWorklogsGetData,
            TInfinite,
            ListWorklogsWorklogsGetParameters,
            ListWorklogsWorklogsGetError
          >
        | QueryFiltersByQueryKey<
            ListWorklogsWorklogsGetSchema,
            ListWorklogsWorklogsGetData,
            TInfinite,
            ListWorklogsWorklogsGetParameters,
            ListWorklogsWorklogsGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary List Worklogs */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListWorklogsWorklogsGetSchema,
            ListWorklogsWorklogsGetData,
            TInfinite,
            ListWorklogsWorklogsGetParameters,
            ListWorklogsWorklogsGetError
          >
        | QueryFiltersByQueryKey<
            ListWorklogsWorklogsGetSchema,
            ListWorklogsWorklogsGetData,
            TInfinite,
            ListWorklogsWorklogsGetParameters,
            ListWorklogsWorklogsGetError
          >
    ): number;
    schema: ListWorklogsWorklogsGetSchema;
    types: {
      parameters: ListWorklogsWorklogsGetParameters;
      data: ListWorklogsWorklogsGetData;
      error: ListWorklogsWorklogsGetError;
    };
  };
}
/** @summary Clock In */
export const clockInWorklogsClockInPost = {
  schema: {
    method: 'post',
    url: '/worklogs/clock_in',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: ClockInWorklogsClockInPostSchema;
  [QraftServiceOperationsToken]: WorklogsService['clockInWorklogsClockInPost'];
};
/** @summary Clock Out */
export const clockOutWorklogsClockOutPut = {
  schema: {
    method: 'put',
    url: '/worklogs/clock_out',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: ClockOutWorklogsClockOutPutSchema;
  [QraftServiceOperationsToken]: WorklogsService['clockOutWorklogsClockOutPut'];
};
/** @summary Get Current */
export const getCurrentWorklogsCurrentGet = {
  schema: {
    method: 'get',
    url: '/worklogs/current',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetCurrentWorklogsCurrentGetSchema;
  [QraftServiceOperationsToken]: WorklogsService['getCurrentWorklogsCurrentGet'];
};
/** @summary List Worklogs */
export const listWorklogsWorklogsGet = {
  schema: {
    method: 'get',
    url: '/worklogs/',
    security: ['HTTPBearer'],
  },
} as {
  schema: ListWorklogsWorklogsGetSchema;
  [QraftServiceOperationsToken]: WorklogsService['listWorklogsWorklogsGet'];
};
export const worklogsService = {
  clockInWorklogsClockInPost,
  clockOutWorklogsClockOutPut,
  getCurrentWorklogsCurrentGet,
  listWorklogsWorklogsGet,
} as const;
type ClockInWorklogsClockInPostSchema = {
  method: 'post';
  url: '/worklogs/clock_in';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type ClockInWorklogsClockInPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type ClockInWorklogsClockInPostData =
  paths['/worklogs/clock_in']['post']['responses']['200']['content']['application/json'];
type ClockInWorklogsClockInPostError =
  paths['/worklogs/clock_in']['post']['responses']['422']['content']['application/json'];
type ClockInWorklogsClockInPostBody = paths['/worklogs/clock_in']['post']['requestBody']['content']['application/json'];
type ClockOutWorklogsClockOutPutSchema = {
  method: 'put';
  url: '/worklogs/clock_out';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type ClockOutWorklogsClockOutPutParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type ClockOutWorklogsClockOutPutData =
  paths['/worklogs/clock_out']['put']['responses']['200']['content']['application/json'];
type ClockOutWorklogsClockOutPutError =
  paths['/worklogs/clock_out']['put']['responses']['422']['content']['application/json'];
type ClockOutWorklogsClockOutPutBody =
  paths['/worklogs/clock_out']['put']['requestBody']['content']['application/json'];
type GetCurrentWorklogsCurrentGetSchema = {
  method: 'get';
  url: '/worklogs/current';
  security: ['HTTPBearer'];
};
type GetCurrentWorklogsCurrentGetParameters = undefined;
type GetCurrentWorklogsCurrentGetData =
  paths['/worklogs/current']['get']['responses']['200']['content']['application/json'];
type GetCurrentWorklogsCurrentGetError = unknown;
type ListWorklogsWorklogsGetSchema = {
  method: 'get';
  url: '/worklogs/';
  security: ['HTTPBearer'];
};
type ListWorklogsWorklogsGetParameters = paths['/worklogs/']['get']['parameters'];
type ListWorklogsWorklogsGetData = paths['/worklogs/']['get']['responses']['200']['content']['application/json'];
type ListWorklogsWorklogsGetError = paths['/worklogs/']['get']['responses']['422']['content']['application/json'];
